import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api from "../api/axios";
import styles from "./OrdersPage.module.css";

const STATUS_BADGE = {
  processing: "badge-amber", confirmed: "badge-purple",
  shipped: "badge-blue", delivered: "badge-green", cancelled: "badge-red",
};

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/orders/my").then(r => setOrders(r.data)).finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="loading-center"><div className="spinner"/></div>;

  return (
    <div className={styles.page}>
      <div className={styles.container}>
        <h1 className={styles.title}>My Orders</h1>

        {orders.length === 0 ? (
          <div className="empty-state">
            <h3>No orders yet</h3>
            <p>Your orders will appear here once you place them through the chatbot</p>
          </div>
        ) : (
          <div className={styles.list}>
            {orders.map(order => (
              <Link to={`/order/${order._id}`} key={order._id} className={styles.orderCard}>
                <div className={styles.orderTop}>
                  <div>
                    <div className={styles.orderId}>#{order._id.slice(-8).toUpperCase()}</div>
                    <div className={styles.orderDate}>{new Date(order.createdAt).toLocaleDateString("en-IN", { day:"numeric", month:"short", year:"numeric" })}</div>
                  </div>
                  <span className={`badge ${STATUS_BADGE[order.orderStatus] || "badge-gray"}`}>
                    {order.orderStatus}
                  </span>
                </div>

                <div className={styles.orderItems}>
                  {order.items.map((item, i) => (
                    <span key={i} className={styles.itemChip}>{item.name} × {item.quantity}</span>
                  ))}
                </div>

                <div className={styles.orderFooter}>
                  <div className={styles.payBadge}>
                    <span className={`badge ${order.paymentInfo.status === "paid" ? "badge-green" : "badge-amber"}`}>
                      {order.paymentInfo.status}
                    </span>
                  </div>
                  <div className={styles.orderTotal}>₹{order.totalPrice.toLocaleString()}</div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
